module.exports = __webpack_public_path__ + "static/media/iconAgenda.c63eb250.svg";